import { render, staticRenderFns } from "./SchoolLink.vue?vue&type=template&id=92d6a48a&scoped=true&"
import script from "./SchoolLink.vue?vue&type=script&lang=js&"
export * from "./SchoolLink.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLink.vue?vue&type=style&index=0&id=92d6a48a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d6a48a",
  null
  
)

export default component.exports